import React, { useEffect, useState, useContext } from "react";
import { getAppearanceData } from "../../hooks/useAppearance";
import AuthContext from "../../contexts/AuthContext";


function Footer() {
    const [fontColour, setFontColour] = useState<string>("");
    const [bgColour, setBgColour] = useState<string>("");

    const { auth } = useContext(AuthContext);

    useEffect(() => {
        async function getData() {
          
            let appearance = await getAppearanceData(auth);
            if (appearance) {
                setFontColour(appearance.fontColour)
                setBgColour(appearance.backgroundColour);
            }
        }

        getData();
    }, [])

    const footerStyle = {
        backgroundColor: bgColour,
        color: fontColour
    }

    const currentYear = new Date().getFullYear();
    const logo = "Images/FYB CM2WebShare - Logo White.SVG";
    const companyLogo = "Images/FYB Logo White - SVG.SVG"

    return (
        <div>
            <div className="Footer">
                <div id="footer" style={footerStyle}>
                    <a href="http://www.fyb.com.au" target="_blank" rel="noopener noreferrer" className="item">
                        <img src={companyLogo} id="footerLogo" alt='FYB Logo' />
                    </a>
                    <div id="footerText">The FYB CM2WebShare is a part of the FYB Connectors <br /> © Copyright FYB Pty Ltd 2016 - {currentYear}</div>
                    <a href="https://www.fyb.com.au/system-connectors/cm2webshare" target="_blank" rel="noopener noreferrer" className="item">
                        <img id="footerRight" src={logo} alt='FYB CM2WebShare Logo' className="noHover" />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer;